const content = {
  selectedWorks: [
    {
      title: "Lync",
      url: "https://lync.global",
      description: `At Waza, I led frontend development on Lync, the company's business banking product that provides businesses in emerging markets with seamless, multi-currency accounts and global payment solutions to operate across borders. I bootstrapped Lync's customer-facing web app from scratch and later built out the backoffice admin dashboard used internally to manage accounts, payments, and compliance. I also built Lync's marketing site.`,
      stack: ["vue", "nuxt", "astro", "typescript"]
    },
    {
    title: "Underpaint",
    url: "https://underpaint.app",
    description: `A BYOA design tool that let's you move from design to code without losing context. Underpaint keeps your visual decisions, structure, and intent connected as you work, so you can design by hand, collaborate with your agent, and turn the result into a real interface without starting over.`,
    stack: ["react", "typescript", "hono", "drizzle", "postgresql"]
    },
    {
      title: "Pouch",
      url: "https://pouch.barnabas.lol",
      description: `Pouch is a concept neobank I designed and built solo, exploring pocket-based banking, splitting incoming money automatically into pockets for bills, savings, and spending`,
      stack: [
        "next.js", "typescript", "gsap", "scss"
      ]
    },
    {
    title: "Virtual Art Gallery",
    url: "https://art.barnabas.lol",
    description: `An interactive 3D art gallery web experience I designed and built using artworks from the Art Institute of Chicago’s open-access collection. It dynamically curates the collection into an explorable gallery, with responsive navigation across desktop and mobile`,
    stack: ["vue", "typescript", "threejs", "art institute of chicago api"]
    },
    {
      title: "Greenpeaks",
      url: "https://greenpeaks.barnabas.lol",
      description: `Greenpeaks is a football-focused foundation aimed at giving young players a path into the game, from grassroots training to talent trials for kids`,
      stack: [
        "astro", "typescript", "tailwindcss"
      ]
    },
    {
      title: "Prolifi",
      url: "https://prolifi.io",
      description: `The marketing website for a billings and collection infrastructure, I built the marketing site, translating Figma designs into pixel-accurate pages, and set up a CMS so the team could manage marketing content independently.`,
      stack: [
        "next.js", "typescript", "motion", "tailwindcss", "payloadcms"
      ]
    },
    {
      title: "Flance",
      url: "https://flance.netlify.app/",
      description: `A freelance management solution.
      Built the UI components using atomic design architecture from the landing page to the onboarding process and the dashboard.`,
      stack: [
        "typescript", "next.js", "styled-components", "framer-motion"
      ]
    },
    {
      title: "PetMobi",
      url: "https://petmobi.netlify.app",
      description: `Landing page for a dog care website`,
      stack: [
        "vue", "scss"
      ]
    },
    {
      title: "Draftboxe",
      url: "https://draftboxe.netlify.app/",
      description: `Inspiration strikes anywhere. Draftboxe lets you capture, organize and share your ideas across any device in form of notes.`,
      stack: [
        "typescript", "next.js", "tailwind-css", "supabase"
      ]
    },
    {
      title: "Pixeler",
      url: "https://pixeler.netlify.app/",
      description: `Search, View and Explore free and high resolution images. Built with unsplash api`,
      stack: [
        "vue", "scss", "unsplash-api"
      ]
    }
  ],
  certifications: [
    {
      title: "UDACITY FULLSTACK DEVELOPER NANODEGREE",
      url: "https://www.udacity.com/course/full-stack-web-developer-nanodegree--nd0044",
      description: `This nanodegree extensively covered various technical skills required to build
      database-backed APIs and
      web applications.`
    }
  ]
}

export default content;
